import React, { useState, useContext, useEffect, Fragment, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import '../assets/css/modal.css';
import Swal from 'sweetalert2';
import ConexContext from "../context/conex/ConexContext";
import { ReactComponent as CorreoIcon } from "../assets/img/iconos/acae_mail.svg";
import { ReactComponent as TrashIcon } from "../assets/img/iconos/acae_trash.svg";
import { ReactComponent as GuardarIcon } from "../assets/img/iconos/acae_save.svg";
import { ReactComponent as CloseIcon } from "../assets/img/iconos/acae_close.svg";
import { ReactComponent as BuscarIcon } from "../assets/img/iconos/acae_zoom.svg";
import Paginacion from './comun/Paginacion';

const CorreosMod = (props) => {
	const { loc, Cargando , peticion } = useContext(ConexContext)
	const [estado_correo, setEstado_correo] = useState('Borrador')
	const [remitente, setRemitente] = useState(null)
	const [copyConf, setCopyConf] = useState(null);//copia
	const [condicionSelec, setCondicionSelec] = useState({
		"campo": null, //campo seleccionado
		"opcion": null, //opcion seleccionada (es, no es, mayor, menor, etc)
		"condicion": "", //valor de la condición
		"agrupacion": 0 //agrupación seleccionada
	});
	const [List, setList] = useState([]); // listado
	const [NRes, setNRes] = useState(0); // Nº de registros con filtro
	const [NTot, setNTot] = useState(0); // Nº de registros con filtro
	const [ListParams, setListParams] = useState({
		num: 15,
		orden: "numAcae ASC NULLS LAST",
		filtro: "",
		ini: 0,
		nomAso: "",
		idAsoc: 0,
		idReg: 0,
		idDojo: 0,
	});
	const [asociadosSelect, setAsociadosSelect] = useState([]);
	const [error, setError] = useState(null); //para mostrar errores
	const [buscarCampo, setBuscarCampo] = useState(""); //para buscar props.campos
	const [opcionesDistinc, setOpcionesDistinc] = useState(null); //opciones para el filtro distinc
	const variablesDisponibles = [
		{ etiqueta: "Nombre", tag: "<span class='variable-mail' contenteditable='false'>nombre</span>" },
		{ etiqueta: "Apellidos", tag: "<span class='variable-mail' contenteditable='false'>apellido</span>" },
		{ etiqueta: "Dojo", tag: "<span class='variable-mail' contenteditable='false'>dojo</span>" },
		{ etiqueta: "Email", tag: "<span class='variable-mail' contenteditable='false'>mail</span>" },
		{ etiqueta: "DNI", tag: "<span class='variable-mail' contenteditable='false'>dni</span>" },
		{ etiqueta: "Última cuota", tag: "<span class='variable-mail' contenteditable='false'>ultima_cuota</span>" },
		{ etiqueta: "Domicilio", tag: "<span class='variable-mail' contenteditable='false'>domicilio</span>" },
		{ etiqueta: "Fecha nacimiento", tag: "<span class='variable-mail' contenteditable='false'>fechaNacimiento</span>" },
		{ etiqueta: "Nº Acae", tag: "<span class='variable-mail' contenteditable='false'>numAcae</span>" },
		{ etiqueta: "Provincia", tag: "<span class='variable-mail' contenteditable='false'>provincia</span>" },
		{ etiqueta: "Teléfono", tag: "<span class='variable-mail' contenteditable='false'>telefono</span>" },
		{ etiqueta: "Último grado", tag: "<span class='variable-mail' contenteditable='false'>ultimo_grado</span>" },
		{ etiqueta: "Último título", tag: "<span class='variable-mail' contenteditable='false'>ultimo_titulo</span>" },
	];
	const cuerpoRef = useRef(null);

	// useHotkeys('alt+g', guarda('Borrador'), { enableOnContentEditable: true, enableOnFormTags: true, enabled: props.show !== 0 && !Cargando })
	useHotkeys('esc', cierra, { enableOnContentEditable: true, enableOnFormTags: true, enabled: props.show !== 0 && !Cargando })

	const [Formu, setFormu] = useState({})
	const [errores, setErrores] = useState(null); //para mostrar errores de correo


	const nFiltros = copyConf?.filtros?.filtros?.reduce((acc, grupo) => acc + grupo.filtros.length, 0) ?? 0

	const pasos = [
		{ titulo: loc('Filtros'), info: nFiltros === 0 ? loc('Sin filtros') : nFiltros + ' ' + loc('condiciones') },
		{ titulo: loc('Destinatarios'), info: asociadosSelect.length + ' ' + loc('seleccionados') },
		{ titulo: loc('Correo'), info: Formu?.titulo ? Formu.titulo : loc('Sin título') }
		// { titulo: loc('Enviar'), info: '' }
	]

	const nombre_opcion = [{
		"=": loc(" es igual a "),
		"!=": loc(" es distinto a "),
		">=": loc(" es mayor o igual que "),
		"<=": loc(" es menor o igual que "),
		">": loc(" es mayor que "),
		"<": loc(" es menor que ")
	}]

	/**
	 * Carga los datos iniciales al abrir el modal (Campos y Datos del correo)
	 */
	useEffect(() => {
		// Si no hay id o el modal está cerrado, no hacemos nada
		if (!props.show) return;
		async function ver() {
			const pet = await peticion('/correos/ver?id=' + props.show);
			if (pet.estado) //algún error 
				return;
			setFormu({
				titulo: pet?.res?.titulo || "",
				cuerpo: pet?.res?.cuerpo || "",
			});
			setRemitente(pet?.res?.remitente || null);
			setEstado_correo(pet?.res?.estado || null);
			// props.setPaso(0);
			const soloAsociados = (pet?.res?.enviados || []).map(elem => elem.asociado);
			setAsociadosSelect(soloAsociados || []);
			setList([]);
		}
		if (props.show > 0)
			ver();
		else if (props.show < 0) {
			setFormu({
				titulo: '',
				cuerpo: '',
			});
			props.setPaso(0);
			setAsociadosSelect([]);
			setList([]);
		}
		// eslint-disable-next-line
	}, [props.show, peticion]);

	/**
	 * Si se muestra el modal y no hay copia, se crea
	 */
	useEffect(() => {
		if (props.show && !copyConf)
			setCopyConf({ "filtros": {
				"nexo": "Y",
				"filtros": [{
					"nexo": "Y",
					"filtros": []
				}]
			} })
	}, [props.show, copyConf])

	/**
	 * Si se cambia la agrupación seleccionada, campo, etc se resetea el error
	 */
	useEffect(() => {
		if (!props.show) return
		setError(null)
	}, [props.show, condicionSelec])

	/**
	 * Si se cambia el campo seleccionado y es de tipo distinc, se piden las opciones
	 */
	useEffect(() => {
		async function distinc() {
			const json = {
				"vista": 'asociado',
				"campos": [
				],
				"filtros": {
					"nexo": "Y",
					"filtros": []
				},
				"agregaciones": [condicionSelec.campo],
				"ini": 0,
				"num": 10000,
				"orden": ""
			}
			const pet = await peticion('/listado/distim_custom', { method: 'POST', json: json })
			if (pet.estado) //algún error
				return;
			if (props.campos[condicionSelec.campo].tfiltro === 'cinturon'){
				setOpcionesDistinc(
					pet.res.res.map((res) => ({
						ultimogrado: res.ultimogrado,
						valorultimogrado: res.valorultimogrado
					}))
					);
			}else{
				if (props.campos[condicionSelec.campo].tfiltro === 'titulo'){
					setOpcionesDistinc(
						pet.res.res.map((res) => ({
							ultimotitulo: res.ultimotitulo,
							valorultimotitulo: res.valorultimotitulo
						}))
						);
				}else{
					setOpcionesDistinc(pet.res.res.map((res) => res[condicionSelec.campo]))
				}
				
			}
			
		}
		setOpcionesDistinc(null)
		if (condicionSelec.campo !== null && (props.campos[condicionSelec.campo].tfiltro === 'distinc' || props.campos[condicionSelec.campo].tfiltro === 'cinturon' || props.campos[condicionSelec.campo].tfiltro === 'titulo'))
			distinc();
		// eslint-disable-next-line
	}, [condicionSelec.campo, props.campos])

	const insertarVariable = (tagHTML) => {
		const editor = cuerpoRef.current;
		if (!editor) return;
		editor.focus();
		// Insertamos el HTML
		if (document.queryCommandSupported('insertHTML')) {
			document.execCommand('insertHTML', false, tagHTML);
		} else {
			const selection = window.getSelection();
			if (selection.getRangeAt && selection.rangeCount) {
				let range = selection.getRangeAt(0);
				range.deleteContents();
				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = tagHTML;
				const frag = document.createDocumentFragment();
				let node;
				while ((node = tempDiv.firstChild)) {
					frag.appendChild(node);
				}
				range.insertNode(frag);
			}
		}
		// MOVER EL CURSOR AL FINAL ABSOLUTO DEL TEXTO
		setTimeout(() => {
			editor.focus();
			const range = document.createRange();
			range.selectNodeContents(editor);
			range.collapse(false);
			const selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
		}, 0);
		// Actualizamos Formu
		setErrores({ ...errores, cuerpoErr: '' });
		setFormu({ ...Formu, cuerpo: editor.innerHTML });
	};

	// Función para seleccionar absolutamente todos los destinatarios filtrados (todas las páginas)
	const seleccionarTodosTotales = async () => {
		if (NTot === 0) return;
		// Hacemos una petición pidiendo todos los registros desde ini=0 hasta pag=NTot
		const pet = await peticion(
			"/correos/listarAsociados?" +
				`ini=0&` +
				`pag=${NTot}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}&` +
				`idDojo=${ListParams.idDojo}`,
			{ method: "POST", json: copyConf }
		);
		if (pet?.res) {
			// setAsociadosSelect(pet.res); // Guardamos todos los resultados devueltos
			setAsociadosSelect(prev => {
				// Creamos un Set con los IDs de los ya seleccionados para búsqueda rápida
				const idsExistentes = new Set(prev.map(item => Number(item.idAso)));
				// Filtramos para obtener solo los resultados nuevos de este listado
				const nuevos = pet.res.filter(item => !idsExistentes.has(Number(item.idAso)));
				// Concatenamos la lista previa con los nuevos
				return [...prev, ...nuevos];
			});
			setErrores({ ...errores, asociadosSelectErr: '' });
		}
	};

	const obtenerPrevisualizacion = () => {
		// Ejemplo el primer usuario seleccionado o uno por defecto
		const ejemplo = asociadosSelect?.[0] || {
			nombre: "Nombre",
			apellido: "Apellido1 Apellido2",
			dojo: "Takezo",
			mail: "correo@gmail.com",
			dni: "12345678X",
			ultima_cuota: "2026",
			domicilio: "Domicilio",
			fechaNacimiento: "24-07-2026",
			numAcae: "01A0001",
			provincia: "Jaén",
			telefono: "666666666",
			ultimo_grado: "1º dan",
			ultimo_titulo: "Shidoin"
		};
		let texto = Formu?.cuerpo || "";
		// Iteramos por las claves de nuestro objeto de ejemplo
		Object.keys(ejemplo).forEach(key => {
			const valor = ejemplo[key] ?? '';
			// REGEX 1: Busca la etiqueta HTML de la variable insertada
			// Coincide con <span ...>key</span> (sin importar atributos o saltos de línea)
			const regexSpan = new RegExp(`<span[^>]*>${key}<\\/span>`, 'gi');
			texto = texto.replace(regexSpan, `<strong>${valor}</strong>`);
			// REGEX 2 (Respaldo): Busca si se ha escrito {key} manualmente en texto plano
			const regexLlaves = new RegExp(`\\{${key}\\}`, 'gi');
			texto = texto.replace(regexLlaves, valor);
		});
		return texto;
	};

	async function guarda(estado) {
		// requeridos
		const error = {}
		if (asociadosSelect.length===0){
			Swal.fire({
				title: loc("Mínimo un destinatario"),
				text: '',
				icon: 'warning'
			});
			return;
		}
		if (Formu.titulo==='') {
			error.tituloErr=loc('El asunto es requerido.')
			Swal.fire({
				title: loc("El asunto es requerido"),
				text: '',
				icon: 'warning'
			});
			setErrores(error)
			return;
		}
		if (Formu.cuerpo==='') {
			error.cuerpoErr=loc('El cuerpo es requerido.')
			Swal.fire({
				title: loc("El cuerpo es requerido"),
				text: '',
				icon: 'warning'
			});
			setErrores(error)
			return;
		}
		// if (Object.keys(error).length > 0) {//algún error
		// 	setErrores(error)
		// 	return;
		// }
		const result = await Swal.fire({
			title: estado === 'Borrador' ? loc("¿Seguro que quieres guardar en borrador el correo?") : loc("¿Seguro que quieres enviar el correo?"),
			showCancelButton: true,
			confirmButtonText: loc("Sí"),
			cancelButtonText: loc("No"),
			icon: "question",
		});
		// Si el usuario confirmó, ejecutamos la petición
		if (result.isConfirmed) {
			let pet
			if (props.show < 0)//inserción
				pet = await peticion('/correos/ins', { method: 'POST', json: {
					cuerpo: Formu.cuerpo,
					titulo: Formu.titulo,
					usuarios: asociadosSelect,
					estado: estado
				} })
			else if (props.show > 0)
				pet = await peticion('/correos/upd', { method: 'POST', json: {
					id: props.show,
					cuerpo: Formu.cuerpo,
					titulo: Formu.titulo,
					usuarios: asociadosSelect,
					estado: estado
				} })
			// if (pet.estado)//algún error 
			// 	return;
			// Si la petición devuelve un estado de error, salimos
			if (pet?.estado ?? false) {
				Swal.fire({
					title: loc("Error"),
					text: pet?.mensaje || loc("No se pudo guardar / enviar el correo."),
					icon: 'error'
				});
				return;
			}
			// Mostramos alerta de éxito
			Swal.fire({
				title: loc("Correo modificado."),
				showConfirmButton: false,
				icon: 'success',
				timer: 1500
			});
			cierra()
			props.listar()
		}
	}

	const getCleanHTML = (element) => {
		// Si no hay texto visible, consideramos el contenido como vacío
		return element.innerText.trim() === '' ? '' : element.innerHTML;
	};

	// Función para listar asociados
	const listar = async () => {
		const pet = await peticion(
			"/correos/listarAsociados?" +
				`ini=${ListParams.ini}&` +
				`pag=${ListParams.num}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}&` +
				`idDojo=${ListParams.idDojo}`,
				{ method: "POST", json: copyConf }
		);
		if (pet?.estado ?? false)
			// algún error
			return null;
		setList(pet.res);
		setNRes(pet.nRes);
		setNTot(pet.nTot);
	};

	function siguiente() {
		if (props.paso === 0){
			// Comprobamos si al menos uno de los grupos contiene un array 'filtros' con elementos
			const error = {}
			const tieneFiltros = copyConf?.filtros?.filtros?.some(
				(grupo) => grupo?.filtros?.length > 0
			);
			if (!tieneFiltros) {
				error.filtrosErr = loc('Los filtros son requeridos.');
			}
			if (Object.keys(error).length > 0) {//algún error
				setErrores(error)
				return;
			}
			listar();
		}
		if (props.paso === 1){
			const error = {}
			if (asociadosSelect.length === 0){
				error.asociadosSelectErr = loc('Tiene que seleccionar mínimo 1 asociado.');
			}
			if (Object.keys(error).length > 0) {//algún error
				setErrores(error)
				return;
			}
		}
		props.setPaso((prev) => prev + 1)
	}

	function anterior() {
		props.setPaso((prev) => prev - 1)
	}

	function cierra() {
		setCopyConf({ "filtros": {
			"nexo": "Y",
			"filtros": [{
				"nexo": "Y",
				"filtros": []
			}]
		} })
		setFormu({})
		setRemitente(null)
		setEstado_correo('Borrador')
		setList([])
		setAsociadosSelect([])
		setErrores(null)
		props.onHide()
	}

	/**
	 * Añade el filtro a la agrupación seleccionada
	 */
	const anadirFiltro = () => {
		setErrores({...errores, filtrosErr: ''})
		//hacen falta todos los datos
		if (condicionSelec.campo === null || condicionSelec.opcion === null || condicionSelec.condicion === "") return setError(loc('Faltan datos'))
		//si es distinc y no está en las opciones, error
		if (opcionesDistinc !== null){
			const condicion = opcionesDistinc.length > 0 && typeof opcionesDistinc[0] === 'number'
			? Number(condicionSelec.condicion) // Convertir a número si los elementos de opcionesDistinc son numéricos
			: condicionSelec.condicion; // Mantener como cadena si son strings
			if (props.campos[condicionSelec.campo].tfiltro === 'distinc' && !opcionesDistinc.includes(condicion)) return setError(loc('Valor no válido'))
		}
		// if (props.campos[condicionSelec.campo].tfiltro === 'distinc' && !opcionesDistinc.includes(condicionSelec.condicion)) return setError(loc('Valor no válido'))
		//si es número o moneda y no es un número, error
		if (['numero', 'moneda'].includes(props.campos[condicionSelec.campo].tfiltro) && isNaN(condicionSelec.condicion)) return setError(loc('Número no válido'))

		let nuevoConf = { ...copyConf }
		//añado el filtro a la agrupación seleccionada
		nuevoConf.filtros.filtros[condicionSelec.agrupacion].filtros.push({
			"campo": condicionSelec.campo,
			"tipo": props.campos[condicionSelec.campo].tfiltro,
			"oper": condicionSelec.opcion,
			"valor": condicionSelec.condicion
		})
		setCopyConf(nuevoConf)
		//reset
		setCondicionSelec({
			...condicionSelec,
			"campo": null,
			"opcion": null,
			"condicion": ""
		})
	}

	/**
	 * Añade una nueva agrupación
	 */
	const anadirNuevaAgrupacion = () => {
		let nuevoConf = { ...copyConf }
		//añado una nueva agrupación
		nuevoConf.filtros.filtros.push({
			"nexo": "Y",
			"filtros": []
		})
		setCopyConf(nuevoConf)
		//reset y selecciono la nueva agrupación como activa
		setCondicionSelec({
			"campo": null,
			"opcion": null,
			"condicion": "",
			"agrupacion": copyConf.filtros.filtros.length - 1
		})
	}

	const handleRowSelect = (item) => {
		setErrores({...errores, asociadosSelectErr: ''})
		setAsociadosSelect(prev => {
			// Comprobamos si el objeto ya existe en el estado usando su idAso
			const exists = prev.some(row => Number(row.idAso) === Number(item.idAso));
			if (exists) {
				// Si ya existe, lo quitamos
				return prev.filter(row => Number(row.idAso) !== Number(item.idAso));
			} else {
				// Si no existe, añadimos el objeto entero
				return [...prev, item];
			}
		});
	};

	//EFFECT
	useEffect(() => {
		if (props.paso===1){
			listar();
		}
		// eslint-disable-next-line
	}, [ListParams]);

	if (props.show === 0)
		return ("")
	else
		return (
			<main className="modal-wrapper">
				<div className="modal-container backdrop content-wrapper">
					<div className="modal-header">
						<div className="flex-wrapper">
							<CorreoIcon className="section-icon curso" />
							<h3>
								{props.show > 0 ? loc("Modificar correo") : loc("Nuevo correo")}
							</h3>
							<span className='label-estado-correo'>{estado_correo || ''}</span>
						</div>
						<CloseIcon
							onClick={cierra}
							className="modal_close-icon"
							alt="Cerrar ventana"
							title="(ESC)"
						/>
					</div>

					<div className="modal-steps">
						{pasos.map((elem, i) => (
							<Fragment key={i}>
								<div
									className={'modal-step' + (props.paso === i ? ' active' : '') + ((props.paso > i && estado_correo !== 'Enviado') ? ' done' : '')}
									onClick={() => { 
										if (estado_correo === 'Enviado') return
										if (props.paso > i) props.setPaso(i) 
										}}
								>
									<span className='modal-step__number'>{i + 1}</span>
									<div className='modal-step__text'>
										<span className='modal-step__titulo'>{elem.titulo}</span>
										<span className='modal-step__info'>{elem.info}</span>
									</div>
								</div>
								{i < pasos.length - 1 &&
									<div className='modal-step__separator' />
								}
							</Fragment>
						))}
					</div>

					<div className="modal-content-scroll form-container crear-curso">
						{props.paso === 0 && 
						<div className='modal-content-scroll'>
							<div className='modal-content-outer-wrapper flex-column'>
								<h4>{loc('Filtros activos')}</h4>
								<div className='active-filter-wrapper'>
									{copyConf && copyConf.filtros.filtros.map((agrupacion, indexAgrup) => ( //recorro las agrupaciones
										<Fragment key={indexAgrup}>
											<div className={'filter-group-wrapper' + (condicionSelec.agrupacion === indexAgrup ? " active" : "")} onClick={() => { setCondicionSelec({ "campo": null, "opcion": null, "condicion": "", "agrupacion": indexAgrup }) }}>
												<div className='filter-group-header'>
													<h4>
														{loc('Agrupación')} {indexAgrup + 1}
														{/* {indexAgrup === condicionSelec.agrupacion && loc(<div className='active-checker'></div>)} */}
													</h4>
													<TrashIcon
														className={'button icon' + (copyConf.filtros.filtros.length === 1 ? ' disabled' : '')}
														onClick={() => {
															if (copyConf.filtros.filtros.length === 1) return
															let nuevoConf = { ...copyConf }
															//quito la agrupación
															nuevoConf.filtros.filtros = nuevoConf.filtros.filtros.filter((elem, i) => i !== indexAgrup)
															//si no queda ninguna agrupación, añado una nueva vacía
															if (nuevoConf.filtros.filtros.length === 0)
																nuevoConf.filtros.filtros.push({
																	"nexo": "Y",
																	"filtros": []
																})
								
															//si la agrupación seleccionada es la que se borra, reseteo
															if (indexAgrup === condicionSelec.agrupacion) {
																setCondicionSelec({
																	"campo": null,
																	"opcion": null,
																	"condicion": "",
																	"agrupacion": 0
																})
															} else {
																// cambiar activa
																setCondicionSelec({
																	"campo": null,
																	"opcion": null,
																	"condicion": "",
																	"agrupacion": 0
																})
															}
															setCopyConf(nuevoConf)
														}}
													/>
												</div>
												<div className='filter-group-content'>
													<div
														key={indexAgrup}
														onClick={() => {
															setCondicionSelec({
																"campo": null,
																"opcion": null,
																"condicion": "",
																"agrupacion": indexAgrup
															})
														}}
														className={"flex-wrapper" + (condicionSelec.agrupacion === indexAgrup ? " activo" : "")}
													>
								
														{agrupacion.filtros.map((filtro, indexFilt) => ( //recorro los filtros de la agrupación
															<Fragment key={indexFilt}>
																<div className='filter-single'>
																	<span>
																		{loc(props.campos[filtro.campo].nombre)}
																	</span>
																	<span>
																		{loc(nombre_opcion[0][filtro.oper])}
																	</span>
																	<span>{loc(filtro.valor)}</span>
																	<TrashIcon
																		className='button icon'
																		onClick={() => {
																			let nuevoConf = { ...copyConf }
																			//quito el filtro
																			nuevoConf.filtros.filtros[indexAgrup].filtros = nuevoConf.filtros.filtros[indexAgrup].filtros.filter((elem, i) => i !== indexFilt)
																			setCopyConf(nuevoConf)
																		}}
																	/>
								
																</div>
								
																{/* Muestra el nexo si dentro de la agrupacion hay mas de un filtro y no es el ultimo */}
																{agrupacion.filtros.length > 1 && indexFilt < agrupacion.filtros.length - 1 &&
																	<div
																		onClick={() => setCopyConf({ //cambio el nexo de la agrupación
																			...copyConf,
																			"filtros": {
																				...copyConf.filtros,
																				"filtros": copyConf.filtros.filtros.map((agrupacion, i) => {
																					if (i === condicionSelec.agrupacion)
																						return {
																							...agrupacion,
																							"nexo": agrupacion.nexo === "Y" ? "O" : "Y"
																						}
																					else
																						return agrupacion
																				})
																			}
																		})}
																		className='nexus-field'
																	>
																		<span>{loc(agrupacion.nexo)}</span>
																	</div>
																}
															</Fragment>
														))}
													</div>
								
												</div>
											</div>
											{/* Muestra el nexo entre agrupaciones si hay mas de una y no es la ultima */}
											{copyConf.filtros.filtros.length > 1 && indexAgrup < copyConf.filtros.filtros.length - 1 &&
								
												<div
													onClick={() => setCopyConf({ //cambio el nexo entre agrupaciones
														...copyConf,
														"filtros": {
															...copyConf.filtros,
															"nexo": copyConf.filtros.nexo === "Y" ? "O" : "Y"
														}
													})}
													className='nexus-group'
												>
													<span>{loc(copyConf.filtros.nexo)}</span>
												</div>
								
											}
										</Fragment>
									))
									}
								</div>
								
								<div className="flex-wrapper underline">
									<button className='button primary'
										onClick={anadirNuevaAgrupacion}
									>
										{loc('Nueva agrupación')}
									</button>
									<button
										className='button tertiary'
										onClick={() => {
											//quito todos los filtros
											setCopyConf({
												"filtros": {
													"nexo": "Y",
													"filtros": [{
														"nexo": "Y",
														"filtros": []
													}]
												}
											})
											//reseteo las opciones
											setCondicionSelec({
												"campo": null,
												"opcion": null,
												"condicion": "",
												"agrupacion": 0
											})
										}}
									>
										{loc('Borrar filtros')}
									</button>
								</div>
								<h4>{loc('Campos')}</h4>
								<div className='search'>
									<form 
										onSubmit={(e) => e.preventDefault()}
									>
										<input
											type="text"
											placeholder={loc('Busca un campo')}
											onChange={(e) => {e.preventDefault(); setBuscarCampo(e.target.value)}}
										/>
										<BuscarIcon alt="buscar" className='buscar' />
									</form>
								</div>
								<div className='available-fields'>
									{props.campos && Object.keys(props.campos)
										.filter((campo) => { //filtro los props.campos por el texto introducido
											if (buscarCampo === "") return true
											else return props.campos[campo].nombre.toLowerCase().includes(buscarCampo.toLowerCase())
										})
										.map((campo) => ( //recorro los props.campos
											<div
												key={campo}
												onClick={() => setCondicionSelec({ //selecciono el campo
													...condicionSelec,
													"campo": campo,
													"opcion": null,
													"condicion": ""
												})}
												className={"button tertiary" + (condicionSelec.campo === campo ? " active" : "")}
											>
												{loc(props.campos[campo].nombre)}
											</div>
										))
									}
								</div>
								{/* Se muestra la ventana de opciones para el filtro si hay uno activo */}
								{condicionSelec.campo !== null &&
									<>
										<h4 className='overline'>{loc('Condiciones')}</h4>
										<div className='flex-wrapper filter-conditions'>
											<span className='field-to-filter'>{loc(props.campos[condicionSelec.campo].nombre)}</span>
											{props.campos[condicionSelec.campo].tfiltro === 'texto' ?
												<>
													<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "=" })}>{loc('es igual a')}</button>
													<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!=" })}>{loc('es diferente a')}</button>
													<div className='search'>
														<form 
															onSubmit={(e) => e.preventDefault()}
														>
															<input
																type="text"
																onChange={(e) => {e.preventDefault(); setCondicionSelec({ ...condicionSelec, "condicion": e.target.value })}}
																placeholder={loc('Valor')}
															/>
														</form>
													</div>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'null_distinc' ?
												<>
													<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "=", "condicion": "Está validado" })}>{loc('es')}</button>
													<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!=", "condicion": "Está validado" })}>{loc('no es')}</button>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'bool' ?
												<>
													<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "=", "condicion": "Verdadero" })}>{loc('es')}</button>
													<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!=", "condicion": "Verdadero" })}>{loc('no es')}</button>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'edad' ?
												<>
													<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "=", "condicion": "Mayor de edad" })}>{loc('es')}</button>
													<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!=", "condicion": "Mayor de edad" })}>{loc('no es')}</button>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'entero' ?
												<>
													<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "="})}>{loc('igual')}</button>
													<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!="})}>{loc('distinto')}</button>
													<input
														type="text"
														onChange={(e) => {
															setCondicionSelec({ ...condicionSelec, "condicion": e.target.value })
														}}
														placeholder={loc('Valor')}
													/>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'cinturon' ?
												<>
													<button className={condicionSelec.opcion === '>=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">=" })}>{loc('es mayor o igual que')}</button>
													<button className={condicionSelec.opcion === '<=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<=" })}>{loc('es menor o igual que ')}</button>
													<button className={condicionSelec.opcion === '>' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">" })}>{loc('es mayor que')}</button>
													<button className={condicionSelec.opcion === '<' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<" })}>{loc('es menor que')}</button>
													<form 
														onSubmit={(e) => e.preventDefault()}
													>
														<select
															onChange={(e) => {e.preventDefault(); setCondicionSelec({
																...condicionSelec,
																"condicion": e.target.value
															})}
															}
														>
															<option value="">{loc('Seleccionar')}</option>
															{opcionesDistinc &&
																opcionesDistinc.map((opcion, index) => (
																	<option key={index} value={opcion?.valorultimogrado}>{opcion?.ultimogrado}</option>
																))
															}
														</select>
													</form>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'titulo' ?
												<>
													<button className={condicionSelec.opcion === '>=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">=" })}>{loc('es mayor o igual que')}</button>
													<button className={condicionSelec.opcion === '<=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<=" })}>{loc('es menor o igual que ')}</button>
													<button className={condicionSelec.opcion === '>' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">" })}>{loc('es mayor que')}</button>
													<button className={condicionSelec.opcion === '<' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<" })}>{loc('es menor que')}</button>
													<form 
														onSubmit={(e) => e.preventDefault()}
													>
														<select
															onChange={(e) => {e.preventDefault(); setCondicionSelec({
																...condicionSelec,
																"condicion": e.target.value
															})}
															}
														>
															<option value="">{loc('Seleccionar')}</option>
															{opcionesDistinc &&
																opcionesDistinc.map((opcion, index) => (
																	<option key={index} value={opcion?.valorultimotitulo}>{opcion?.ultimotitulo}</option>
																))
															}
														</select>
													</form>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'tiempo' ?
												<>
													<button className={condicionSelec.opcion === '>=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">=" })}>{loc('es mayor o igual que')}</button>
													<button className={condicionSelec.opcion === '<=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<=" })}>{loc('es menor o igual que ')}</button>
													<button className={condicionSelec.opcion === '>' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">" })}>{loc('es mayor que')}</button>
													<button className={condicionSelec.opcion === '<' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<" })}>{loc('es menor que')}</button>
													<input
														type="number"
														min="0"
														onChange={(e) => {
															setCondicionSelec({
																...condicionSelec,
																"condicion": e.target.value
															});
														}}
														value={condicionSelec?.condicion || ''}
														placeholder={loc('Días')}
													/>
												</>
												: props.campos[condicionSelec.campo].tfiltro === 'distinc' ?
													<>
														<button className={condicionSelec.opcion === '=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "=" })}>{loc('es')}</button>
														<button className={condicionSelec.opcion === '!=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "!=" })}>{loc('no es')}</button>
														<form 
															onSubmit={(e) => e.preventDefault()}
														>
															<select
																onChange={(e) => {e.preventDefault(); setCondicionSelec({
																	...condicionSelec,
																	"condicion": e.target.value
																})}
																}
															>
																<option value="">{loc('Seleccionar')}</option>
																{opcionesDistinc &&
																	opcionesDistinc.map((opcion, index) => (
																		<option key={index}>{opcion}</option>
																	))
																}
															</select>
														</form>
													</>
													: ['numero', 'moneda'].includes(props.campos[condicionSelec.campo].tfiltro) &&
													<>
														<button className={condicionSelec.opcion === '>=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">=" })}>{loc('es mayor o igual que')}</button>
														<button className={condicionSelec.opcion === '<=' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<=" })}>{loc('es menor o igual que ')}</button>
														<button className={condicionSelec.opcion === '>' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": ">" })}>{loc('es mayor que')}</button>
														<button className={condicionSelec.opcion === '<' ? ('button secondary active') : ('button secondary')} onClick={() => setCondicionSelec({ ...condicionSelec, "opcion": "<" })}>{loc('es menor que')}</button>
														<input
															type="text"
															onChange={(e) => {
																setCondicionSelec({ ...condicionSelec, "condicion": e.target.value })
															}}
															placeholder={loc('Valor')}
														/>
													</>
											}
											<button
												className='button primary'
												onClick={anadirFiltro}
											>
												{loc('Añadir')}
											</button>
											<p>{error && error}</p>
										</div>
									</>
								}
							</div>
							
						</div>
						}
						{props.paso === 1 && 
							<div className="backdrop content-wrapper">
								<div className="filtering">
									<Paginacion
										nrPag={List.length}
										NRes={NRes}
										NTot={NTot}
										Ini={ListParams.ini}
										setListParams={setListParams}
										Num={ListParams.num}
										Filtro={ListParams.filtro}
									/>
								</div>
								<div className="table-container">
									<table className="table-cursos">
										<thead className="table-headers">
											<tr>
												<th className="large-s-column">
													{loc("Check")}
												</th>
												<th className="large-s-column">
													{loc("Nombre")}
												</th>
												<th className="large-s-column">
													{loc("Apellidos")}
												</th>
												<th className="large-s-column grow-column">
													{loc("Correo")}
												</th>
												<th className="large-column">
												</th>
											</tr>
										</thead>
										<tbody className="table-results">
											{List.map((elem, i) => (
												<Fragment key={i}>
													<tr>
														<td className="large-s-column">
															<input
																title='Check'
																type="checkbox"
																className="carnet-checkbox"
																checked={asociadosSelect.some(row => Number(row.idAso) === Number(elem.idAso))}
																onChange={() => handleRowSelect(elem)}
															/>
														</td>
														<td className="large-s-column">{elem.nombre}</td>
														<td className="large-s-column">{elem.apellido}</td>
														<td className="large-s-column grow-column">{elem.mail}</td>
													</tr>
												</Fragment>
											))}
										</tbody>
									</table>
								</div>
								<div className='selected-panel'>
									<div className='selected-panel__header underline'>
										<div className='selected-panel__count'>
											<span className='selected-panel__count-num'>{asociadosSelect.length}</span>
											<span>{loc('seleccionados')}</span>
										</div>
										<button
											type="button"
											className='button secondary'
											onClick={seleccionarTodosTotales}
										>
											{loc(`Seleccionar todos (${NTot})`)}
										</button>
										<button
											type="button"
											className='button tertiary'
											onClick={()=>setAsociadosSelect([])}
										>
											<TrashIcon />
											{loc('Vaciar lista')}
										</button>
									</div>
									<p className='selected-panel__hint'>
										{loc('Puedes volver al props.paso anterior, aplicar otro filtro y seguir añadiendo asociados a esta misma selección antes de redactar el correo.')}
									</p>
									{(!asociadosSelect || asociadosSelect.length === 0) ?
										<div className='selected-panel__empty'>
											<p>{loc('No hay asociados seleccionados')}</p>
											<p>{loc('Selecciona uno o varios asociados en la tabla.')}</p>
										</div>
										:
										<div className='selected-panel__chips'>
											{asociadosSelect.map((aso, i) => (
												<Fragment key={i}>
													<div className='selected-chip'>
														<div className='selected-chip__text'>
															<p>{aso.nombre} {aso.apellido}</p>
															<span className='text-ellipsis'>{aso.mail}</span>
														</div>
														<CloseIcon
															className='button icon'
															title={loc('Quitar selección')}
															onClick={() => handleRowSelect(aso)}
														/>
													</div>
												</Fragment>
											))}
										</div>
									}
								</div>
							</div>
						}
						{props.paso === 2 &&
							<div className='modal-content-outer-wrapper flex-column'>
								<div className='mail-view'>
									<div className='mail-view__header'>
										<div className='mail-view__row'>
											<span className='mail-view__label'>{loc("De")}:</span>
											{remitente ? 
												(
													<><strong>{remitente.nombre_completo || `${remitente.nombre} ${remitente.apellido}`}</strong> <span className='mail-view__mail'>{remitente.mail}</span></>
												):(
													<span className='mail-view__value text-italic'>{loc("Se completará al enviar")}</span>
												)
											}
										</div>
										<div className='mail-view__row'>
											<span className='mail-view__label'>{loc("Para")}:</span>
											<div className='mail-view__value mail-view__recipients'>
												{asociadosSelect && asociadosSelect.length > 0 ? (
													asociadosSelect.map((aso, i) => (
														<Fragment key={i}>
															<span className='mail-view__contact'>
																<strong>{aso?.nombre} {aso?.apellido}</strong>
																<span className='mail-view__mail'>{aso?.mail || loc("Sin correo")}</span>
															</span>
														</Fragment>
													))
												) : (
													loc("No hay destinatarios seleccionados.")
												)}
											</div>
										</div>
											<div className='mail-view__row'>
												<span className='mail-view__label'>{loc("Asunto")}:</span>
												<div className='relative-container' style={{ width: "100%" }}>
													<span className='mail-view__value mail-view__value--grow'>
														<input
															type="text"
															style={{ width: "100%" }}
															value={Formu?.titulo ?? ""}
															onChange={(self) => {
																setErrores({...errores, tituloErr: ''})
																setFormu({
																	...Formu,
																	titulo: self.target.value,
																})
															}}
															placeholder={loc("Asunto")}
															disabled={estado_correo === 'Enviado'}
															className={(estado_correo === 'Enviado' ? 'desactivar':'')}
														/>
													</span>
													<p className="error">{errores?.tituloErr}</p>
												</div>
										</div>
									</div>
									<div className='mail-view__compose'>
										<div className='variables-header'>
											<p>{loc("Cuerpo")}</p>
											<span>{loc("Haz clic para insertar variables:")}</span>
										</div>
										<div className={'relative-container ' + (estado_correo === 'Enviado' ? 'desactivar':'')} style={{ width: "100%" }}>
											<div className='available-fields'>
												{variablesDisponibles.map((varItem, idx) => (
													<button
														key={idx}
														type="button"
														className='button tertiary variable-chip'
														onClick={() => insertarVariable(varItem.tag)}
														title={`${loc("Insertar")} ${varItem.tag}`}
													>
														<span className='variable-chip__add'>+</span>
														{varItem.etiqueta}
													</button>
												))}
											</div>
											<div
												contentEditable={true}
												style={{ width: "100%", minHeight: "150px", maxHeight: "350px" }}
												className={'mail-body-editor ' + (estado_correo === 'Enviado' ? 'desactivar':'')}
												// onInput={(e) => {
												// 	setErrores({...errores, cuerpoErr: ''});
												// 	setFormu({ ...Formu, cuerpo: e.currentTarget.innerHTML });
												// }}
												// onBlur={(e) => {
												// 	setFormu({ ...Formu, cuerpo: e.currentTarget.innerHTML });
												// }}
												onInput={(e) => {
													if (estado_correo === 'Enviado') return;
													const value = getCleanHTML(e.currentTarget);
													setErrores({ ...errores, cuerpoErr: '' });
													setFormu({ ...Formu, cuerpo: value });
												}}
												onBlur={(e) => {
													if (estado_correo === 'Enviado') return;
													const value = getCleanHTML(e.currentTarget);
													setFormu({ ...Formu, cuerpo: value });
												}}
												ref={(el) => {
													if (estado_correo === 'Enviado') return;
													cuerpoRef.current = el;
													if (el && document.activeElement !== el) {
														if (el.innerHTML !== (Formu?.cuerpo ?? "")) {
															el.innerHTML = Formu?.cuerpo ?? "";
														}
													}
												}}
												disabled={estado_correo === 'Enviado'}
											/>
											<p className="error">{errores?.cuerpoErr}</p>
										</div>
									</div>
									{Formu?.cuerpo && (
										<div className='mail-preview'>
											<p className='mail-preview__label'>
												{loc("Previsualización (ejemplo con el primer asociado):")}
											</p>
											<div
												className='mail-preview__body'
												dangerouslySetInnerHTML={{ __html: obtenerPrevisualizacion() }}
											/>
										</div>
									)}
								</div>
							</div>
						}
						{/* {props.paso === 3 &&
						<div className="modal-content-scroll form-container crear-curso">
							<div className='modal-content-outer-wrapper flex-column'>
								<div className='mail-view'>
									<div className='mail-view__header'>
										{remitente ? (
											<div className='mail-view__row'>
												<span className='mail-view__label'>{loc("De")}:</span>
												<span className='mail-view__value'>
													<strong>{remitente.nombre_completo || `${remitente.nombre} ${remitente.apellido}`}</strong> <span className='mail-view__mail'>{remitente.mail}</span>
												</span>
											</div>
										) : (
											<div className='mail-view__row'>
												<span className='mail-view__label'>{loc("De")}:</span>
												<span className='mail-view__value'>
													<strong>{loc("Se completará al enviar")}</strong> <span className='mail-view__mail'></span>
												</span>
											</div>
										)}
										<div className='mail-view__row'>
											<span className='mail-view__label'>{loc("Para")}:</span>
											<div className='mail-view__value mail-view__recipients'>
												{asociadosSelect && asociadosSelect.length > 0 ? (
													asociadosSelect.map((aso, i) => (
														<Fragment key={i}>
															<span className='mail-view__contact'>
																<strong>{aso?.nombre} {aso?.apellido}</strong>
																<span className='mail-view__mail'>{aso?.mail || loc("Sin correo")}</span>
															</span>
														</Fragment>
													))
												) : (
													loc("No hay destinatarios registrados en este correo.")
												)}
											</div>
										</div>
										<div className='mail-view__row'>
											<span className='mail-view__label'>{loc("Asunto")}:</span>
											<span className='mail-view__value'>{Formu?.titulo}</span>
										</div>
									</div>
									<div 
										className='mail-view__body'
										dangerouslySetInnerHTML={{ __html: Formu?.cuerpo }}
									/>
								</div>
							</div>
						</div>
						} */}
					</div>
					<div className="modal-footer">
						<div className="flex-wrapper flex-end">
							<p className="error">{errores?.filtrosErr}</p>
							<p className="error">{errores?.asociadosSelectErr}</p>
							<button className="button tertiary" onClick={cierra}>
								{loc("Cancelar")}
							</button>
							<>
								{props.paso > 0 && (estado_correo !== 'Enviado' || !estado_correo) && (
									<button
										type="button"
										onClick={anterior}
										className="button primary"
									>
										{loc("Anterior")}
									</button>
								)}
								{props.paso < 2 && (
									<button
										type="button"
										onClick={siguiente}
										className="button primary"
									>
										{loc("Siguiente")}
									</button>
								)}
								{props.paso === 2 && (estado_correo !== 'Enviado' || !estado_correo) && (
									<button
										type="button"
										onClick={()=>guarda('Borrador')}
										className="button primary"
									>
										{loc("Guardar")}
										<GuardarIcon alt="Guardar" title="Guardar" />
									</button>
								)}
								{props.paso === 2 && (estado_correo === 'Borrador' || !estado_correo) && (
									<button
										type="button"
										onClick={()=>guarda('Enviado')}
										className="button primary"
									>
										{loc("Enviar")}
										<CorreoIcon alt="Enviar" title="Enviar" />
									</button>
								)}
							</>
						</div>
					</div>
				</div>
			</main>
		);
}

export default CorreosMod;
